import { Component, inject, Input, output } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import {
  SiaMenuService,
  SiaPermissionsService,
  SiaTooltipDirective,
  SiaTranslatePipe,
  SiaUsersService,
} from '@sia/shared';
import { SiaBaseComponent } from '../sia-base/sia-base.component';

@Component({
  selector: 'sia-grid-footer',
  templateUrl: './sia-grid-footer.component.html',
  styleUrls: ['./sia-grid-footer.component.scss'],
  standalone: true,
  imports: [
    SiaTooltipDirective,
    SiaTranslatePipe,
    MatPaginator,
    MatFormField,
    MatSelect,
    MatOption,
    MatLabel,
  ],
})
export class SiaGridFooterComponent extends SiaBaseComponent {
  private menuService = inject(SiaMenuService);
  private siaPermissionsService = inject(SiaPermissionsService);
  private userService = inject(SiaUsersService);

  private _componentId: string = '';
  @Input() set componentId(value: string) {
    this._componentId = value;
  }

  @Input() set allowUpdate(value: boolean | undefined) {
    this.actions = this.actions.filter((x) => x.id != 'update');
    if (value) {
      let actions = [
        {
          id: 'update',
          description: 'Aggiorna massivo',
          allowAllSelection: true,
          allowSelection: true,
          processOnFire: false,
          filterSelectionByCrud: true,
          alwaysPermitSelection: false,
          filterProp: 'update',
        },
      ];

      this.actions = [...this.actions, ...actions];
    }
  }
  @Input() set allowSelectIds(value: string) {
    this.actions = this.actions.filter((x) => x.id != 'ids');
    if (value) {
      let actions = [
        {
          id: 'ids',
          description: value,
          allowAllSelection: true,
          allowSelection: true,
          processOnFire: false,
          filterSelectionByCrud: false,
          alwaysPermitSelection: false,
          filterProp: 'ids',
        },
      ];

      this.actions = [...this.actions, ...actions];
    }
  }
  @Input() set allowMerge(value: boolean | undefined) {
    this.actions = this.actions.filter((x) => x.id != 'merge');
    if (value) {
      let actions = [
        {
          id: 'merge',
          description: 'Unisci',
          allowAllSelection: true,
          allowSelection: true,
          processOnFire: false,
          filterSelectionByCrud: true,
          alwaysPermitSelection: false,
          filterProp: 'update',
        },
      ];

      this.actions = [...this.actions, ...actions];
    }
  }
  @Input() set allowComparison(value: boolean | undefined) {
    this.actions = this.actions.filter((x) => x.id != 'comparison');
    if (value) {
      let actions = [
        {
          id: 'comparison',
          description: 'Confronta',
          allowAllSelection: true,
          allowSelection: true,
          processOnFire: false,
          filterSelectionByCrud: true,
          alwaysPermitSelection: true,
          filterProp: 'update',
        },
      ];

      this.actions = [...this.actions, ...actions];
    }
  }
  @Input() set allowDelete(value: boolean | undefined) {
    this.actions = this.actions.filter((x) => x.filterProp != 'delete');
    if (value) {
      let actions = [
        {
          id: 'delete',
          description: 'Elimina massivo',
          allowAllSelection: true,
          allowSelection: true,
          processOnFire: false,
          filterSelectionByCrud: false,
          alwaysPermitSelection: false,
          filterProp: 'delete',
        },
      ];
      this.actions = [...this.actions, ...actions];
    }
  }
  @Input() gridViewMode: string = '';
  //#endregion
  pageIndexChange = output<number>();

  @Input() set pageIndex(value: number) {
    this._pageIndex = value;
  }

  private _exportEnabled: boolean = false;
  get exportEnabled(): boolean {
    return this._exportEnabled;
  }
  @Input() set exportEnabled(value: boolean) {
    this._exportEnabled = value;
    this.actions = this.actions.filter((x) => x.filterProp != 'export');
    if (value) {
      let actions = [
        {
          id: 'excel',
          description: 'Esporta in Excel',
          allowAllSelection: true,
          allowSelection: true,
          processOnFire: false,
          filterSelectionByCrud: false,
          alwaysPermitSelection: true,
          filterProp: 'export',
        },
        // {
        //   id: 'excel-all',
        //   description: 'Esporta tutto in Excel',
        //   allowAllSelection: false,
        //   allowSelection: false,
        //   processOnFire: true,
        //   filterSelectionByCrud: false,
        //   alwaysPermitSelection: false,
        //   filterProp: 'export',
        // },
        {
          id: 'pdf',
          description: 'Esporta in Pdf',
          allowAllSelection: true,
          allowSelection: true,
          processOnFire: false,
          filterSelectionByCrud: false,
          alwaysPermitSelection: true,
          filterProp: 'export',
        },
        // {
        //   id: 'pdf-all',
        //   description: 'Esporta tutto in pdf',
        //   allowAllSelection: false,
        //   allowSelection: false,
        //   processOnFire: true,
        //   filterSelectionByCrud: false,
        //   alwaysPermitSelection: false,
        //   filterProp: 'export',
        // },
      ];
      this.actions = [...actions, ...this.actions];
    }
  }
  //#endregion
  confirmAction = output<boolean>();

  actions: {
    id: string;
    description: string;
    allowAllSelection: boolean;
    allowSelection: boolean;
    processOnFire: boolean;
    filterSelectionByCrud: boolean;
    alwaysPermitSelection: boolean;
    filterProp: string;
  }[] = [];
  get pageIndex(): number {
    return this._pageIndex;
  }

  @Input() set pageCount(value: number) {
    this._pageCount = value;
  }
  get pageCount(): number {
    return this._pageCount;
  }

  //#endregion
  pageSizeChange = output<number>();
  @Input() set pageSize(value: number) {
    this._pageSize = value;
  }
  get pageSize(): number {
    return this._pageSize;
  }

  @Input() set totalCount(value: number) {
    this._totalCount = value;
  }
  get totalCount(): number {
    return this._totalCount;
  }
  view: string = '';
  private _selectedAction: any;
  //#endregion
  selectedActionChange = output<any>();
  get selectedAction(): any {
    return this._selectedAction;
  }
  @Input() set selectedAction(value: any) {
    this._selectedAction = value;
    this.selectedActionChange.emit(value);
  }
  private _pageIndex: number = 0;
  private _pageSize: number = 0;
  private _totalCount: number = 0;
  private _pageCount: number = 0;

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    super();
  }

  //#region public
  paginationChanged(e: any) {
    if (!e) return;
    this.pageSizeChange.emit(e.pageSize);
    this.pageIndexChange.emit(e.pageIndex);
  }
  confirmCurrentAction() {
    this.confirmAction.emit(true);
  }
  //#endregion
}
